<template>
    <div style="display: contents">
        <v-menu
            v-model="showNot" 
            transition="slide-y-transition"
            min-width="350" 
            max-width="350"
            content-class="round-card"
            offset-y 
            nudge-left="200">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-badge right overlap color="red" :content="notificationCount" :value="$store.getters.notifications.length > 0">
                        <v-icon :class="$eventBusUtility.iconAppBarColor">notifications</v-icon>
                    </v-badge>
                </v-btn>
            </template>

            <v-list two-line class="pa-0 notifications-list background-2" style="max-height: 353px; overflow-y: auto;">
                <v-subheader class="pt-2 fs12i" style="height:38px">Notifiche</v-subheader>
                <template v-for="(notification, not) in $store.getters.notifications">
                    <v-list-item
                        id="list-item-notification"
                        style="height:62px"
                        ripple
                        @click.stop="handleNotificationClick(notification)"
                        @mousedown.middle.stop.prevent="openInNewTab(notification.data.modelDef + '-show', notification.data.modelDefId)"
                        :key="not">
                        <v-list-item-avatar v-if="notification.data.type == 'task'">
                            <v-avatar v-if="$store.getters.avatars[notification.data.user_id]"
                                class="custom-avatar"
                                :size="34" 
                                v-ripple
                                :style="{'background-image': 'url(' + $store.getters.avatars[notification.data.user_id] + ')'}">
                            </v-avatar>
                            <v-avatar v-else :class="$eventBusUtility.bgColor(notification.data.user_id)" :size="34">
                                <span class="white--text fs14" v-if="notification.data.creator">{{ notification.data.creator.charAt(0) }}</span>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-avatar v-else-if="notification.data.type == 'maillog'">
                            <v-avatar
                                size="34px" 
                                style="min-width: 34px; width: 34px; height:34px; border-radius: 50px; margin:auto"
                                class="primary">
                                <v-icon class="fs18i" color="white">drafts</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>
                        
                        <v-list-item-avatar v-else-if="notification.data.type == 'quotation-signed'">
                            <v-avatar
                                size="34px"
                                style="min-width: 34px; width: 34px; height:34px; border-radius: 50px; margin:auto"
                                class="primary">
                                <v-icon class="fs18i" color="white">mdi-file-check-outline</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-avatar v-else-if="notification.data.type == 'event'">
                            <v-avatar
                                size="34px"
                                style="min-width: 34px; width: 34px; height:34px; border-radius: 50px; margin:auto"
                                class="primary">
                                <v-icon class="fs18i" color="white">mdi-calendar-clock</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-avatar v-else>
                            <v-avatar v-if="$store.getters.avatars[notification.data.user_id]"
                                class="custom-avatar"
                                :size="34" 
                                v-ripple
                                :style="{'background-image': 'url(' + $store.getters.avatars[notification.data.user_id] + ')'}">
                            </v-avatar>
                            <v-avatar v-else :class="$eventBusUtility.bgColor(notification.data.user_id)" :size="34">
                                <span class="white--text fs14" v-if="notification.data.creator">{{ notification.data.creator.charAt(0) }}</span>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content class="py-2 pl-0 pr-2">
                            <v-list-item-title class="fs11i"><span class="fw500">{{notification.data.title}}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="fs11i">{{notification.data.subtitle}}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="notification.data.text" class="fs11i">{{notification.data.text}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-list-item-action-text class="fs11i">{{ formatNotificationTime(notification.created_at) }}</v-list-item-action-text>
                            <v-tooltip top class="fs12i">
                                <template v-slot:activator="{ on }">
                                    <v-icon class="fs20i" color="grey lighten-1" @click.stop="$eventBusUtility.changeNotificationStatus([notification.id], 'read')">email</v-icon>
                                </template>
                                <span class="fs11i">Segna come letta</span>
                            </v-tooltip>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider inset :key="not+'_divider'"></v-divider>
                </template>
                <v-list-item v-if="!thereAreNotifications">
                    <v-list-item-content>
                        <v-list-item-title class="fs11i text-center fw500">Non ci sono notifiche per te</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <div class="text-center pt-2 fs11i fw500" v-if="countOtherNotifications"> + {{ countOtherNotifications }} altre notifiche</div>
                <v-list-item id="list-item-notification" style="height:62px">
                    <v-list-item-content>
                        <v-btn text small ripple @click="openAllNotifications" color="primary" class="fs11i" style="margin:auto">Vedi tutte le notifiche</v-btn>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-menu
            v-if="archive && $vuetify.breakpoint.mdAndUp"
            v-model="showNotArchive" 
            transition="slide-y-transition"
            min-width="350" 
            max-width="350"
            offset-y 
            nudge-left="200">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-badge right overlap color="info" :content="archiveCount" :value="$store.getters.notificationsArchive.length > 0">
                        <v-icon :class="$eventBusUtility.iconAppBarColor">mdi-folder-outline</v-icon>
                    </v-badge>
                </v-btn>
            </template>        

            <v-list two-line class="pa-0 notifications-list background-2 round-card" style="max-height: 353px; overflow-y: auto;">
                <v-subheader class="pt-2 fs12i" style="height:38px">Notifiche Archivio</v-subheader>
                <template v-for="(notification, not) in $store.getters.notificationsArchive">
                    <v-list-item
                        id="list-item-notification"
                        style="height:62px"
                        ripple
                        @click="$router.push({ path: '/profile/download/' })"
                        @mousedown.middle.stop.prevent="openInNewTab('profile-download')"
                        :key="not">

                        <v-list-item-avatar>
                            <v-avatar v-if="$store.getters.avatars[notification.data.user_id]"
                                class="custom-avatar"
                                :size="34" 
                                v-ripple
                                :style="{'background-image': 'url(' + $store.getters.avatars[notification.data.user_id] + ')'}">
                            </v-avatar>
                            <v-avatar v-else :class="$eventBusUtility.bgColor(notification.data.user_id)" :size="34">
                                <span class="white--text fs14" v-if="notification.data.creator">{{ notification.data.creator.charAt(0) }}</span>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content class="py-2 pl-0 pr-2">
                            <v-list-item-title class="fs11i"><span class="fw500">{{notification.data.title}}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="fs11i">{{notification.data.subtitle}}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="notification.data.text" class="fs11i">{{notification.data.text}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-list-item-action-text class="fs11i">{{ formatNotificationTime(notification.created_at) }}</v-list-item-action-text>
                            <v-tooltip top class="fs12i">
                                <template v-slot:activator="{ on }">
                                    <v-icon class="fs18i" color="grey lighten-1" @click.stop="$eventBusUtility.changeNotificationStatus([notification.id], 'read')">email</v-icon>
                                </template>
                                <span class="fs11i">Segna come letta</span>
                            </v-tooltip>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider inset :key="not+'_divider'"></v-divider>
                </template>
                <v-list-item v-if="$store.getters.notificationsArchive.length == 0">
                    <v-list-item-content>
                        <v-list-item-title class="fs11i text-center fw500">Non ci sono notifiche per te</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <div class="text-center pt-2 fs11i fw500" v-if="countOtherArchiveNotifications"> + {{ countOtherArchiveNotifications }} altre notifiche</div>
                <v-list-item id="list-item-notification" style="height:62px">
                    <v-list-item-content>
                        <v-btn text small ripple @click="$router.push({ path: '/profile/download/' })" color="primary" class="fs11i" style="margin:auto">Vai all'archivio</v-btn>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>

</template>

<script>

export default {
    name: 'notifications-menu',
    props: {
        dark: {
            type: Boolean,
            default: false,
        },
        archive: {
            type: Boolean,
            default: true
        },
    },
	data: () => ({
		showNot: false,
		showNotArchive: false,
		avatars: [],
	}),

	created() {
		this.getNotifications()
	},

	computed: {
		autoReadEnabled() {
			return !this.$store.getters.getSettingByModel('viewing', 'notification_disable_auto_read')
		},
		thereAreNotifications() {
			if(this.$store.getters.notificationsCount) {
				return this.$store.getters.notificationsCount > 0 ? true : false
			} else return false
        },
        notificationCount() {
            return this.$store.getters.notificationsCount > 99 ? '99+' : this.$store.getters.notificationsCount
        },

        countOtherNotifications() {
            let count = this.$store.getters.notificationsCount - this.$store.getters.notifications.length
            return count > 0 ? count : false
        },

        archiveCount() {
            let count = this.$store.getters.notificationsArchiveCount
            return count > 99 ? '99+' : count
        },

        countOtherArchiveNotifications() {
            let count = this.$store.getters.notificationsArchiveCount - this.$store.getters.notificationsArchive.length
            return count > 0 ? count : false
        }
	},

	mounted() {
		this._updateNotificationsHandler = () => this.getNotifications()
		this.$eventBusUtility.$on('updateNotifications', this._updateNotificationsHandler)
    },

    beforeDestroy() {
        this.$eventBusUtility.$off('updateNotifications', this._updateNotificationsHandler)
    },

	methods: {
		handleNotificationClick(notification) {
			this.showNot = false
			if (this.autoReadEnabled) {
				this.$store.commit('REMOVE_NOTIFICATION', notification.id)
				this.$eventBusUtility.changeNotificationStatus([notification.id], 'read')
			}
			if (notification.data.modelDef === 'whatsappconversations') {
				this.$router.push({
					path: '/whatsapp',
					query: { conversation_id: notification.data.modelDefId }
				}).catch(() => {})
			} else if (notification.data.modelDef === 'event') {
				this.$router.push({
					path: '/calendar',
					query: { event_id: notification.data.modelDefId }
				}).catch(() => {})
			} else if (notification.data.modelDef === 'calendar') {
				this.$router.push({
					path: '/calendar'
				}).catch(() => {})
			} else if (notification.data.type === 'google_account') {
				this.$router.push({
					path: '/profile/calendars'
				}).catch(() => {})
			} else if (notification.data.modelDef === 'edocuments' && notification.data.type === 'import_edocuments') {
				// resoconto del lotto con i motivi dei documenti non importati
				this.$router.push({
					path: '/invoices/edocuments',
					query: notification.data.report ? { import_report: notification.data.report } : {}
				}).catch(() => {})
			} else {
				let routeName = notification.data.modelDef + '-show'
				try {
					let resolved = this.$router.resolve({ name: routeName, params: { id: notification.data.modelDefId } })
					if (resolved && resolved.route.name !== undefined) {
						this.$router.push({ name: routeName, params: { id: notification.data.modelDefId } }).catch(() => {})
					}
				} catch (e) {
					// route non esistente
				}
			}
		},

		openAllNotifications() {
			this.$router.push({ name: 'notifications'})
		},

		openInNewTab(routeName, params) {
			let route
			if (params) {
				route = this.$router.resolve({ name: routeName, params: { id: params } })
			} else {
				route = this.$router.resolve({ name: routeName })
			}
			window.open(route.href, '_blank')
		},

		formatNotificationTime(date) {
			if (date) {
				return moment(date).startOf('second').fromNow()
			} else {
				return ''
			}
		},

		getNotifications() {
			this.axios.post('notifications/', {filters: {status: 'unread'}, page: 1, per_page: 10, exclude_archives: true}).then(response => {
				this.$store.commit('SET_NOTIFICATIONS', response.data)
			}, response => {
				// error callback
			})
			this.axios.post('notifications/', {filters: {status: 'unread'}, page: 1, per_page: 10, only_archives: true}).then(response => {
				this.$store.commit('SET_NOTIFICATIONS_ARCHIVE', response.data)
			}, response => {
				// error callback
			})
		},
	}
}
</script>
<style>
    .notifications-list .v-list-item__title {
        font-size: 11px !important;
    }
</style>
